const REGISTER_USER_START = "REGISTER_USER_START";
const REGISTER_USER_SUCC = "REGISTER_USER_SUCC";
const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";

const initialState = {
    data: {},
    isfetching: false,
    fail: false,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case REGISTER_USER_START: {
            return {
                ...state,
                isfetching: true,
            }
        }
        case REGISTER_USER_SUCC: {
            return {
                ...state,
                isfetching: false,
                data: action.data,
            }
        }
        case REGISTER_USER_FAIL: {
            return {
                ...state,
                error: action.error,
                isfetching: false,
                fail: true,
            }
        }
        default: return state
    }
}
